import { createFileRoute } from '@tanstack/react-router';
import { VersionsPage } from '../../features/settings/components/versions-page.js';

export const Route = createFileRoute('/admin/versions')({ component: VersionsPage });
